import React from 'react';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const noop = () => {};

function CCClipboard({ id, children, onCopy, copy, className }) {
  return (
    <CopyToClipboard text={copy} onCopy={onCopy}>
      <button
        data-testid={id ?? 'action-copy-link'}
        type="button"
        className={className || 'link-copy-box-button'}
      >
        {children}
      </button>
    </CopyToClipboard>
  );
}

CCClipboard.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  copy: PropTypes.string.isRequired,
  id: PropTypes.string,
  onCopy: PropTypes.func,
};

CCClipboard.defaultProps = {
  className: null,
  id: null,
  onCopy: noop,
};

export default CCClipboard;
